module.exports = __webpack_public_path__ + "static/img/pc.1e245bf8.jpg";